'use strict';

(function() {
  var widgetsModule = angular.module('atex.aceui.ui.widgets', ['atex.aceui.service']);

  widgetsModule.config(function($compileProvider, $provide) {
    widgetsModule.compileProvider = $compileProvider;
    widgetsModule.provide = $provide;
  });

  /**
   * We provide custom functions for registering directives and
   * services into the widgets module. This enables us to handle
   * registrations lazily (late in runtime), which Angular doesn't
   * support by itself.
   *
   * When support for lazy registration into a module is introduced
   * in Angular, these shortcuts will be removed.
   */

  widgetsModule.registerDirective = function(directiveName, directive) {
    return widgetsModule.compileProvider.directive(directiveName, directive);
  };

  widgetsModule.registerService = function(serviceName, service) {
    return widgetsModule.provide.factory(serviceName, service);
  };
})();
